import { Formik } from "formik";
import { Grid, TextField, FormLabel, Autocomplete, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useBussinesAreaStore } from "../../../hooks/useBussinesAreaStore";
import { useProductClassificationStore } from "../../../hooks/useProductClassificationStore";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useWayToPayStore } from "../../../hooks/useWayToPayStore";
import { usePriceListStore } from "../../../hooks/usePriceListStore";
import { useSegmentStore } from "../../../hooks/useSegmentStore";
import { ApiStatus } from "../../../types/api/status";
import { useSellerStore } from "../../../hooks/useSellerStore";

const dataVendedor = [
    { id: 1, name: 'area demo', idbranchoffice: '1' },
]

const dataSegmentacion = [
    { id: 1, name: 'clasificacion demo', idbranchoffice: '1' },
]

const dataPriceList = [
    { id: 1, name: 'Unidad', abbreviation: 'Ud.' },
    { id: 2, name: 'Kilogramo', abbreviation: 'Kg' },
]


export const SectionCommercialInformation: React.FC<any> = (props): JSX.Element | any => {

    const { dataCommercial, setDataCommercial, currentSection, handlePrevSection, handleNextSection, sections, clearState } = props;

    const { getWayToPayByCompany } = useWayToPayStore();
    const { getPriceListByCompany } = usePriceListStore();
    const { getSegments } = useSegmentStore();
    const { status: statusBussines, bussinesArea, getBussinesAreaByCompany } = useBussinesAreaStore()
    const { getSellers } = useSellerStore()

    const [loadingdata, setLoadingdata] = useState<boolean>(false);

    const [wayToPays, setWayToPays] = useState<any>([]);
    const [waytopaySelected, setwaytopaySelected] = useState<any>('');
    const [sellers, setSellers] = useState<any>([]);
    const [sellerSelected, setSellerSelected] = useState<any>('');
    const [segmentations, setSegmentations] = useState<any>([]);
    const [segmentationSelected, setSegmentationsSelected] = useState<any>('');
    const [priceList, setPriceList] = useState<any>([]);
    const [priceListSelected, setPriceListSelected] = useState<any>('');
    const [selectedBussines, setSelectedBussines] = useState<any>(null)

    useEffect(() => {
        getWayToPayApi();
        getSellersAPI();
        // getSegmentationApi();
        // getPriceListApi();
        getBussinesAreaByCompany()
    }, []);

    useEffect(() => {
        if (bussinesArea.length > 0 && dataCommercial.idbussines_area) {
            const data = bussinesArea?.find(row => row.id === dataCommercial.idbussines_area)
            setSelectedBussines(data)
        }
    }, [dataCommercial?.idbussines_area, bussinesArea])

    useEffect(() => {
        if (dataCommercial.idwaytopay && wayToPays) {
            setCustomWaytopay(dataCommercial.idwaytopay, wayToPays)
        }
    }, [dataCommercial.idwaytopay, wayToPays])

    const setCustomWaytopay = (idwaytopay, wayToPays) => {
        const data = wayToPays.find(waytopay => waytopay.idway_to_pay == idwaytopay);
        return setwaytopaySelected(data);
    }

    useEffect(() => {
        if (dataCommercial.idsalesman && sellers) {
            setCustomSeller(dataCommercial.idsalesman, sellers)
        }
    }, [dataCommercial.idseller, sellers])

    const setCustomSeller = (idseller, sellers) => {
        const data = sellers.find(seller => seller.id == idseller);
        return setSellerSelected(data);
    }

    useEffect(() => {
        if (dataCommercial.idsegment && segmentations) {
            setCustomSegmentation(dataCommercial.idsegment, segmentations)
        }
    }, [dataCommercial.idsegment, segmentations])

    const setCustomSegmentation = (idsegment, segmentations) => {
        const data = segmentations.find(segmentation => segmentation.id == idsegment);
        return setSegmentationsSelected(data);
    }

    useEffect(() => {
        if (dataCommercial.idlistprice && priceList) {
            setCustomPriceList(dataCommercial.idlistprice, priceList)
        }
    }, [dataCommercial.idlistprice, priceList])

    const setCustomPriceList = (idlistprice, priceList) => {
        const data = priceList.find(list => list.id == idlistprice);
        return setSegmentationsSelected(data);
    }

    const getWayToPayApi = async (search = '') => {
        try {
            setLoadingdata(true);
            const response = await getWayToPayByCompany(search);
            if (!response) {
                setWayToPays([]); setLoadingdata(false); return false;
            } else {
                setWayToPays(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getSellersAPI = async (search = '') => {
        try {
            setLoadingdata(true);
            const response = await getSellers(search);
            if (!response) {
                setSellers([]); setLoadingdata(false); return false;
            } else {
                setSellers(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const getSegmentationApi = async (search = '') => {
        try {
            setLoadingdata(true);
            const response = await getSegments(search);
            if (!response) {
                setSegmentations([]); setLoadingdata(false); return false;
            } else {
                setSegmentations(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const getPriceListApi = async (search = '') => {
        try {
            setLoadingdata(true);
            const response = dataSegmentacion;
            // const response = await getPriceListByCompany(search);
            if (!response) {
                setPriceList([]); setLoadingdata(false); return false;
            } else {
                setPriceList(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values) => {
        let errors: any = {};
        if (!values.idwaytopay) errors.idwaytopay = "el campo es requerido";
        if (!values.idsalesman) errors.idsalesman = "el campo es requerido";
        if (!values.idbussines_area) errors.idbussines_area = "el campo es requerido";
        // if(!values.idseller) errors.idseller = "el campo es requerido";
        // if (!values.idsegment) errors.idsegment = "el campo es requerido";
        // if(!values.idlistprice) errors.idlistprice = "el campo es requerido";
        return errors;
    }

    const onCancel = () => {
        handlePrevSection && handlePrevSection();
    }

    const onSubmit = async (values) => {
        setDataCommercial(values)
        handleNextSection && handleNextSection();
    }

    return (
        <Grid sx={{ height: '100%', position: 'relative' }}>
            <Formik initialValues={dataCommercial} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Grid container sx={{ maxHeight: '65vh', overflowY: 'scroll', paddingRight: '5px' }}>
                                <Grid item container xs={12} spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Formas de pago:</FormLabel>
                                        <Autocomplete
                                            id="idwaytopay"
                                            size="small"
                                            value={!!waytopaySelected ? waytopaySelected : null}
                                            options={wayToPays || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.wayToPay || ''}
                                            isOptionEqualToValue={(option, value) => option.wayToPay === value?.wayToPay}
                                            renderInput={(params) =>
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idwaytopay && touched.idwaytopay ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setwaytopaySelected(newValue)
                                                setFieldValue('idwaytopay', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Vendedor:</FormLabel>
                                        <Autocomplete
                                            id="idsalesman"
                                            size="small"
                                            value={!!sellerSelected ? sellerSelected : null}
                                            options={sellers || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option, value) => option.name === value?.name}
                                            renderInput={(params) =>
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idsalesman && touched.idsalesman ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setSellerSelected(newValue)
                                                setFieldValue('idsalesman', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Área de negocio:</FormLabel>
                                        <Autocomplete
                                            disablePortal
                                            id="idbussines_area"
                                            value={selectedBussines}
                                            options={statusBussines === ApiStatus.FETCHING ? [] : bussinesArea}
                                            getOptionLabel={(option) => option.name || ""}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            fullWidth
                                            renderInput={(params) =>
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idbussines_area && touched.idbussines_area ? true : false}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {statusBussines === ApiStatus.FETCHING && <CircularProgress color="inherit" size={20} />}
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            }
                                            onChange={(e, newValue) => {
                                                setSelectedBussines(newValue);
                                                setFieldValue('idbussines_area', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12} md={6}>
                                        <FormLabel>Segmentacion:</FormLabel>
                                        <Autocomplete
                                            id="idsegment"
                                            size="small"
                                            value={!!segmentationSelected ? segmentationSelected : null}
                                            options={segmentations || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option, value) => option.name === value?.name}
                                            renderInput={(params) =>
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idsegment && touched.idsegment ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setSegmentationsSelected(newValue)
                                                setFieldValue('idsegment', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid> */}
                                    {/* <Grid item xs={12} md={6}>
                                        <FormLabel>Lista de precio:</FormLabel>
                                        <Autocomplete
                                            id="idlistprice"
                                            size="small"
                                            value={!!priceListSelected ? priceListSelected : null}
                                            options={priceList || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                            renderInput={(params) => 
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idlistprice && touched.idlistprice ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setPriceListSelected(newValue)
                                                setFieldValue('idlistprice', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid> */}
                                </Grid>
                            </Grid>
                            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                                <ModalFooter
                                    buttonType="submit"
                                    confirmText={'Siguiente'}
                                    onConfirm={handleSubmit}
                                    cancelText={"Atrás"}
                                    onCancel={onCancel}
                                />
                            </div>
                        </form>
                    )
                }}
            </Formik>
        </Grid>
    )
}